import { Injectable, inject } from '@angular/core';
import { NbToastrService } from '@nebular/theme';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { GlobalErrorHandlerService } from '@vmspdb/ui/common';
import { AuthRunEffects } from '@vmspdb/ui/store';
import { tap } from 'rxjs';
import { catchError, concatMap } from 'rxjs/operators';
import { JobTypeRepositoryService } from '../../repositories';
import { VOID } from '../../shared/utils';
import * as JobTypesActions from './job-types.actions';

@Injectable()
export class JobTypeEffects extends AuthRunEffects {
  private readonly repository = inject(JobTypeRepositoryService);
  private readonly errors = inject(GlobalErrorHandlerService);
  private readonly toastr = inject(NbToastrService);

  deleteJobType$ = createEffect(
    () => {
      return this.actions$.pipe(
        ofType(JobTypesActions.deleteJobType),
        concatMap(({ item }) => this.repository.delete(item.uuid || '')),
        tap(() => this.toastr.success('Job type deleted', 'Success')),
        catchError((err) => {
          this.toastr.danger(err, `Error`);
          this.errors.reportCaughtError(err);
          return VOID;
        }),
      );
    },
    { dispatch: false },
  );

  constructor() {
    const actions$ = inject(Actions);

    super(actions$);
  }
}
